"use strict";

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var IdentityFingerprintLined = function IdentityFingerprintLined(_ref) {
  var className = _ref.className,
      style = _ref.style,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["className", "style"]);

  var styleProp = Object.assign({
    verticalAlign: 'middle'
  }, style);
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    className: (0, _classnames["default"])(className),
    viewBox: "0 0 24 24",
    style: styleProp
  }, otherProps), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.83 6.876a.5.5 0 01-.706-.046C20.09 6.792 16.7 3 12 3 7.242 3 3.911 6.789 3.878 6.827a.5.5 0 01-.756-.654C3.269 6 6.79 2 12 2c5.167 0 8.727 4 8.876 4.171a.5.5 0 01-.046.705zM12 9c3.576 0 5.007 4.6 5.021 4.644a.5.5 0 00.958-.288C17.913 13.138 16.322 8 12 8a5.362 5.362 0 00-5.2 3.125c-1.44 3.033-.65 7.508.31 8.683a.5.5 0 00.7.071.5.5 0 00.071-.7c-.716-.878-1.464-4.919-.181-7.623A4.369 4.369 0 0112 9zm5.477 10a4.8 4.8 0 01-3.8-1.176 4.787 4.787 0 01-1.18-3.293.5.5 0 00-.468-.53.485.485 0 00-.53.467 5.732 5.732 0 001.458 4.051 5.524 5.524 0 004.112 1.491c.148 0 .3 0 .452-.01a.5.5 0 00.479-.523.508.508 0 00-.523-.477zM12 5c-7.977 0-9 6.68-9 12.5a.5.5 0 001 0C4 9.439 6.393 6 12 6a7.476 7.476 0 015.789 2.374 7.1 7.1 0 011.825 4.618c0 1.388-.553 3.008-2.114 3.008-2.123 0-2.515-1.176-2.97-2.538C14.145 12.308 13.708 11 12 11c-1.91 0-3.244 1.891-3.244 4.6a7.221 7.221 0 001.357 4.287A5.29 5.29 0 0014.5 22a.5.5 0 000-1 4.323 4.323 0 01-3.589-1.717A6.2 6.2 0 019.756 15.6c0-1.789.771-3.6 2.244-3.6.944 0 1.191.61 1.582 1.779C14.035 15.138 14.657 17 17.5 17c1.863 0 3.114-1.611 3.114-4.008A8.129 8.129 0 0018.532 7.7 8.452 8.452 0 0012 5z",
    fill: "currentColor"
  })));
};

var _default = IdentityFingerprintLined;
exports["default"] = _default;